// BIBLIOTECA DE TĂIAT POLIGOANE, luată o singură dată și în singurul fel care
// merge în amândouă lumile.
//
// `polygon-clipping` ÎȘI MINTE TIPURILE, iar minciuna se vede numai în browser:
// `dist/polygon-clipping.d.ts` declară `export function difference(...)`, deci
// TypeScript primește fără să clipească `import * as pc` și `pc.difference`.
// Numai că build-ul ESM — cel pe care îl ia Vite pentru browser — n-are niciun
// export numit: se termină cu `var index = {union, intersection, xor,
// difference}; export default index`. Acolo `pc.difference` e `undefined`, iar
// apelul cade cu «(void 0) is not a function».
//
// Sub vitest nu se vede NICIODATĂ: acolo se rezolvă `main`, adică build-ul CJS,
// unde interop-ul expune chiar funcțiile ca export-uri numite. O suită verde
// peste un ecran gol — s-a întâmplat, cu hașura zonei edificabile.
//
// De-aia capcana stă ÎNTR-UN SINGUR LOC. Două module care o ocolesc fiecare pe
// cont propriu sunt două module care se pot strica separat, iar al doilea o va
// afla tot din pagină.
import * as polygonClipping from "polygon-clipping";
import type { MultiPolygon, Polygon } from "polygon-clipping";

type Geom = Polygon | MultiPolygon;

export interface Taietor {
  union(geom: Geom, ...geoms: Geom[]): MultiPolygon;
  intersection(geom: Geom, ...geoms: Geom[]): MultiPolygon;
  difference(geom: Geom, ...geoms: Geom[]): MultiPolygon;
  xor(geom: Geom, ...geoms: Geom[]): MultiPolygon;
}

type Namespace = Partial<Taietor> & { default?: Partial<Taietor> };

/** `null` dacă biblioteca nu expune nimic — atunci cine cheamă spune ce
 *  lipsește, în loc să apeleze ceva nedefinit. */
export const taietor: Taietor | null = (() => {
  const ns: Namespace = polygonClipping as unknown as Namespace;
  if (typeof ns.difference === "function") return ns as Taietor;
  if (typeof ns.default?.difference === "function") return ns.default as Taietor;
  return null;
})();

/** Biblioteca, sau o eroare cu nume. */
export function taie(): Taietor {
  if (!taietor) throw new Error("polygon-clipping nu expune operațiile");
  return taietor;
}
